const CONTENT_LANGUAGE_MANAGER_ROLES: ReadonlySet<string> = new Set([
  'company_admin',
  'company_owner',
  'company_suadmin',
  'client_admin',
])

export const canManageContentLanguage = (role: unknown): boolean =>
  CONTENT_LANGUAGE_MANAGER_ROLES.has(
    String(role ?? '')
      .trim()
      .toLowerCase(),
  )
